var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -17,
    y: -20.9492,
    width: 160.065,
    height: 160.065
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20px)",
      clipPath: "url(#bgblur_0_269_1198_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_269_1198)",
    "data-figma-bg-blur-radius": 40
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.0327,
    cy: 59.0835,
    r: 40.0327,
    fill: "url(#paint0_linear_269_1198)",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.0327,
    cy: 59.0835,
    r: 39.4608,
    stroke: "white",
    strokeOpacity: 0.25,
    strokeWidth: 1.14379,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0207 41.7944C61.4772 41.2619 62.3011 41.2619 62.7575 41.7944L67.1334 46.8996C67.7694 47.6416 67.2422 48.7878 66.265 48.7878H57.5132C56.536 48.7878 56.0088 47.6416 56.6448 46.8996L61.0207 41.7944Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 59.734V61.8019H51.2836V72.5078H48.7215V61.8019H45.3176V59.734H54.6875ZM62.1203 72.6359C60.9246 72.6359 59.8266 72.3553 58.8262 71.7941C57.8257 71.2329 57.0327 70.4581 56.4471 69.4699C55.8614 68.4695 55.5686 67.3409 55.5686 66.0843C55.5686 64.8398 55.8614 63.7235 56.4471 62.7353C57.0327 61.7348 57.8257 60.954 58.8262 60.3928C59.8266 59.8316 60.9246 59.5509 62.1203 59.5509C63.3281 59.5509 64.4262 59.8316 65.4144 60.3928C66.4148 60.954 67.2018 61.7348 67.7752 62.7353C68.3608 63.7235 68.6536 64.8398 68.6536 66.0843C68.6536 67.3409 68.3608 68.4695 67.7752 69.4699C67.2018 70.4581 66.4148 71.2329 65.4144 71.7941C64.414 72.3553 63.3159 72.6359 62.1203 72.6359ZM62.1203 70.3483C62.8889 70.3483 63.566 70.1775 64.1516 69.8359C64.7373 69.4821 65.1948 68.9819 65.5242 68.3353C65.8536 67.6886 66.0183 66.9383 66.0183 66.0843C66.0183 65.2303 65.8536 64.486 65.5242 63.8516C65.1948 63.205 64.7373 62.7109 64.1516 62.3693C63.566 62.0276 62.8889 61.8568 62.1203 61.8568C61.3516 61.8568 60.6684 62.0276 60.0706 62.3693C59.485 62.7109 59.0275 63.205 58.698 63.8516C58.3686 64.486 58.2039 65.2303 58.2039 66.0843C58.2039 66.9383 58.3686 67.6886 58.698 68.3353C59.0275 68.9819 59.485 69.4821 60.0706 69.8359C60.6684 70.1775 61.3516 70.3483 62.1203 70.3483ZM79.5088 63.6869C79.5088 64.3701 79.344 65.0106 79.0146 65.6085C78.6974 66.2063 78.1911 66.6882 77.4957 67.0542C76.8125 67.4202 75.9462 67.6032 74.897 67.6032H72.7558V72.5078H70.1937V59.734H74.897C75.8852 59.734 76.7271 59.9048 77.4225 60.2464C78.1179 60.588 78.6364 61.0577 78.978 61.6555C79.3318 62.2533 79.5088 62.9305 79.5088 63.6869ZM74.7872 65.5353C75.4948 65.5353 76.0194 65.3767 76.361 65.0594C76.7027 64.73 76.8735 64.2725 76.8735 63.6869C76.8735 62.4425 76.178 61.8202 74.7872 61.8202H72.7558V65.5353H74.7872Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_269_1198",
    x: -17,
    y: -20.9492,
    width: 160.065,
    height: 160.065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_269_1198"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_269_1198"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_269_1198",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_269_1198_clip_path",
    transform: "translate(17 20.9492)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.0327,
    cy: 59.0835,
    r: 40.0327
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_1198",
    x1: 34.9473,
    y1: 33.0622,
    x2: 109.076,
    y2: 65.2497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544F4F",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544F4F",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopTest);
export default __webpack_public_path__ + "static/media/topTest.e802f945ccd002592d96a6e9644b0509.svg";
export { ForwardRef as ReactComponent };